import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Suspense } from "react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import AnalyticsRouteTracker from "@/components/AnalyticsRouteTracker";
import RouteSEO from "@/components/RouteSEO";
import { gatedRoutes, NotFoundRoute, publicRoutes } from "./routeRegistry";

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <>
      <ScrollToTop />
      <AnalyticsRouteTracker />
      <RouteSEO />
      <Suspense
        fallback={
          <p role="status" aria-live="polite" className="container py-4 text-sm text-muted-foreground">
            A carregar página…
          </p>
        }
      >
        <Switch>
          {publicRoutes.map(route => (
            <Route key={route.path} path={route.path} component={route.component} />
          ))}
          {gatedRoutes.map(route => (
            <Route key={route.path} path={route.path} component={route.component} />
          ))}
          <Route component={NotFoundRoute} />
        </Switch>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
          <CookieBanner />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
